import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { DirtyChecker2 } from '../core/dirty-checker-2';
import { EmploymentExpensesModel } from '../../cmg-1003/models';
import { Cmg1003EmploymentExpensesStore } from './employment-expenses.store';

@Injectable({ providedIn: 'root' })
export class Cmg1003EmploymentExpensesQuery extends Query<EmploymentExpensesModel> {
  protected store: Cmg1003EmploymentExpensesStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);

  constructor() {
    const store = inject(Cmg1003EmploymentExpensesStore);

    super(store);

    this.store = store;
  }
}
